/**
 * @generated SignedSource<<60c0ee45c55f672de7f53029ea3f177c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Plugin_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Order_query">;
  readonly " $fragmentType": "Plugin_query";
};
export type Plugin_query$key = {
  readonly " $data"?: Plugin_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"Plugin_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Plugin_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Order_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "74bf61eee60842981340fa490a3b0a7b";

export default node;
